import { FC } from "react";
import { Spinner } from "react-bootstrap";
import { ResourcesService } from "../../services/ResourcesService";

export const CenteredSpinner: FC = () =>
    <div className={`d-flex justify-content-center spinner-wrapper`}>
        <Spinner animation="border" variant="primary"><span className="visually-hidden">{ResourcesService.translate('Loading...')}</span></Spinner>
    </div>